export let TimelineGridEventCssVars = /*#__PURE__*/function (TimelineGridEventCssVars) {
  TimelineGridEventCssVars["xPosition"] = "--x-position";
  TimelineGridEventCssVars["width"] = "--width";
  return TimelineGridEventCssVars;
}({});